import "./styles.css";
import { t, type MessageKey } from "./i18n";
import type { Language } from "./types";

const root = document.querySelector<HTMLDivElement>("#terms-root");
if (!root) throw new Error("Terms root is missing");

root.innerHTML = `
  <header class="about-page-header">
    <a class="about-back" href="/" data-i18n="aboutBackHome"></a>
    <button class="language-toggle" type="button" data-language-toggle>EN</button>
  </header>
  <main class="about-page-main">
    <p class="eyebrow">QUIYA / TERMS</p>
    <h1 data-i18n="termsTitle"></h1>
    <p class="about-lead" data-i18n="termsIntro"></p>
    <div class="about-divider" aria-hidden="true"></div>
    <section class="about-block">
      <h2 data-i18n="termsAgeTitle"></h2>
      <p data-i18n="termsAgeBody"></p>
    </section>
    <section class="about-block">
      <h2 data-i18n="termsAffiliateTitle"></h2>
      <p data-i18n="termsAffiliateBody"></p>
    </section>
    <section class="about-block">
      <h2 data-i18n="termsContentTitle"></h2>
      <p data-i18n="termsContentBody"></p>
    </section>
    <section class="about-block">
      <h2 data-i18n="termsIpTitle"></h2>
      <p data-i18n="termsIpBody"></p>
      <p class="image-use-note" data-i18n="termsImageUse"></p>
    </section>
    <section class="about-block">
      <h2 data-i18n="termsDisclaimerTitle"></h2>
      <p data-i18n="termsDisclaimerBody"></p>
    </section>
    <section class="about-block">
      <h2 data-i18n="termsProhibitedTitle"></h2>
      <p data-i18n="termsProhibitedBody"></p>
    </section>
    <section class="about-block">
      <h2 data-i18n="termsGoverningTitle"></h2>
      <p data-i18n="termsGoverningBody"></p>
    </section>
    <section class="about-block">
      <h2 data-i18n="termsChangesTitle"></h2>
      <p data-i18n="termsChangesBody"></p>
    </section>
    <div class="about-divider" aria-hidden="true"></div>
    <p class="about-block"><a href="/about/" data-i18n="termsPrivacyLink"></a></p>
    <small data-i18n="termsUpdated"></small>
  </main>
`;

let language: Language = localStorage.getItem("quiya-language") === "en" ? "en" : "ja";

function applyLanguage(): void {
  document.documentElement.lang = language;
  document.querySelectorAll<HTMLElement>("[data-i18n]").forEach((element) => {
    element.textContent = t(language, element.dataset.i18n as MessageKey);
  });
  document.querySelectorAll<HTMLButtonElement>("[data-language-toggle]").forEach((button) => {
    button.textContent = language === "ja" ? "EN" : "日本語";
  });
}

applyLanguage();

document.querySelectorAll<HTMLButtonElement>("[data-language-toggle]").forEach((button) => {
  button.addEventListener("click", () => {
    language = language === "ja" ? "en" : "ja";
    localStorage.setItem("quiya-language", language);
    applyLanguage();
  });
});
